import React from 'react'

import ANTDModal from '../../../../../shared/antd/ANTDModal'
import ANTDTable from '../../../../../shared/antd/ANTDTable'

const ViewFileRecord = ({
  t,
  viewModal,
  handleCloseModal,
  handleSingleViewChange,
  viewColumns,
  PAGE_SIZE,
}) => {
  return (
    <ANTDModal
      title={t('txt_FileRecords')}
      centered
      open={viewModal?.open}
      onCancel={handleCloseModal}
      footer={false}
      width={1100}
    >
      <ANTDTable
        columns={viewColumns}
        dataSource={viewModal?.data?.list || []}
        pagination={{
          lastFetched: viewModal?.data?.pageNo,
          current: viewModal?.data?.pageNo,
          pageSize: PAGE_SIZE,
          total: viewModal?.data?.lastPage * PAGE_SIZE,
          responsive: true,
        }}
        scroll={{
          x: 700,
        }}
        loading={viewModal?.loader}
        onChange={handleSingleViewChange}
      />
    </ANTDModal>
  )
}

export default ViewFileRecord
